var isFirefox;	// ano, takto nepekne globalne, abychom to mohli pouzivat i v zanorenych funkcich (coz bychom nemohli, kdyby to bylo this.isFirefox)

jQuery.fn.extend({
  addClassSVG: function(className) {
    return this.each(function() {
      	var cssClass = $(this).attr('class');
		$(this).attr('class', cssClass + ' ' + className);
		return $(this);
    });
  },
  removeClassSVG: function(className) {
    return this.each(function() {
    	if (!className) {	// no argument, remove all classes
    		$(this).attr('class', '');
    		return $(this);
    	}

      	var cssClass = $(this).attr('class');

      	className.split(' ').forEach(function(el) {
    		cssClass = cssClass.replace(el, '');
    	})
		$(this).attr('class', cssClass);

		return $(this);
    });
  }
});


Array.prototype.clone = function() {
    return this.slice(0);
};

function nop() { return false; }

function addSpecialCharsToWords(words, newLetters){
	if (words.length < 1) return words;
	if (!newLetters) return words;

	var newWords = [];
	var chars = [];
	var doubledChars = ['"', '('];
	var combiningChars = ['@', '/', '-'];
	if(newLetters.indexOf('"') >= 0){
		chars.push('""');
	}
	if(newLetters.indexOf('(') >= 0 || newLetters.indexOf(')') >= 0){
		chars.push('()');
	}
	if(newLetters.indexOf('?') >= 0){
		chars.push('?');
	}
	if(newLetters.indexOf(';') >= 0){
		chars.push(';');
	}
	if(newLetters.indexOf(':') >= 0){
		chars.push(':');
	}
	if(newLetters.indexOf('!') >= 0){
		chars.push('!');
	}
	if(newLetters.indexOf('-') >= 0){
		chars.push('-');
	}
	if(newLetters.indexOf('@') >= 0){
		chars.push('@');
	}
	if(newLetters.indexOf('/') >= 0){
		chars.push('/');
	}
	if(newLetters.indexOf('.') >= 0){
		chars.push('.');
	}
	if(newLetters.indexOf(',') >= 0){
		chars.push(',');
	}

	if(chars.length < 1) return words;

	for(var i = 0; i < words.length; i++){
		var chosenChar = chars[Math.floor(Math.random() * chars.length)];
		if(doubledChars.indexOf(chosenChar.charAt(0)) >= 0){
			newWords.push(chosenChar.charAt(0) + words[i] + chosenChar.charAt(1));
		} else if(combiningChars.indexOf(chosenChar) >= 0 && i + 1 < words.length){
			newWords.push(words[i] + chosenChar + words[i + 1]);
			i++;
		} else if(combiningChars.indexOf(chosenChar) >= 0){
			newWords.push(words[i]);
		} else newWords.push(words[i] + chosenChar);
	}

	return newWords;
}

function isElementInViewport(el) {
	//special bonus for those using jQuery
	if (typeof jQuery === "function" && el instanceof jQuery) {
		el = el[0];
	}

	var rect = el.getBoundingClientRect();

	return (
		rect.top >= 0 &&
		rect.left >= 0 &&
		rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /*or $(window).height() */
		rect.right <= (window.innerWidth || document.documentElement.clientWidth) /*or $(window).width() */
	);
}

commonGameFunctions = {

GAME_CONDITION_TIME: 'time',
//GAME_CONDITION_LIVES: 'lives',
//GAME_CONDITION_POINTS: 'points',

setConstants: function(c) {
	if(c === null) { alert(localizedTexts.games.dbDataError); }
	jQuery.extend(true, this.c, c);
},
setGraphics: function(g) {
	jQuery.extend(true, this.g, g);
},
setLinks: function(l) {
	jQuery.extend(true, this.l, l);
},
setTexts: function(t) {
	jQuery.extend(true, this.t, t);
},

setCommonGameSetting: function(roundId, gameObject) {

	this.levelColorAlternative = this.levelColorAlternative !== undefined ? this.levelColorAlternative : this.levelColor;
	this.gameObject = gameObject;

	this.common = {
		'colors': this.getCommonColors(gameObject.isDarkmode, gameObject.isVisuallyImpaired),
	};

	this.c = {
		"countdownStart": 3,
		"roundId": roundId
	};
	this.g = {
		isVisuallyImpaired: gameObject.isVisuallyImpaired,
		width: 800,
		height: 450,
		sidebarWidth: 0,
		headerHeight: 50,
		allBackgroundColor: gameObject.isDarkmode ? "#383838" : "white",
		backgroundColor: this.levelColor,
		levelColor: this.levelColor,
		opacity: 0.75,
		message1: {
			width: 600,
			color:  this.common.colors.black ,//'#5ab6d5', //'#88d0e6',
			fill: 'white',
			borderColor: '#8FC64E',
			fontFamily: 'Open Sans, Arial',
			fontStyle: 'bold',
			fontSize: 24
		},
		message2: {
			width: 600,
			color: '#5e8cb5',//'#5ab6d5', //'#88d0e6',
			fill: 'black',
			borderColor: '#8FC64E',
			fontFamily: 'Open Sans, Arial',
			fontStyle: 'normal',
			fontSize: 20
		},
		message11: {
			width: 600,
			color: 'gray',//'#5ab6d5', //'#88d0e6',
			fill: 'black',
			borderColor: '#8FC64E',
			fontFamily: 'Open Sans, Arial',

			fontSize: 16
		},
		pause: {
			width: 400,
			color: '#444444',
			fill: '#799863',
			borderColor: '#8FC64E',
			fontFamily: 'Open Sans, Arial',
			fontStyle: 'bold',
			fontSize: 34
		},
		pauseDescription: {
			color: '#444444',
			borderColor: '#8FC64E',
			fontFamily: 'Open Sans, Arial',
			fontStyle: 'bold',
			fontSize: 18
		},
		countdownCircle: {
			radius: 50,
			border: 7,
			color: gameObject.levelColor,
			fontFamily: 'Monospace',
		},
		lives: {
			perLine: 5,
			offset: 30,
			deadOpacity: 0.2
		}
	};
	this.l = {};

	this.t = {
		loadWordsError: localizedTexts.games.connectionError,
		level: 'Level',
		pause: localizedTexts.games.pause,
		pauseText: localizedTexts.games.pauseText,
		results: {
			words: localizedTexts.games.words,
			points: localizedTexts.games.points,
			accuracy: localizedTexts.games.accuracy,
			mistakes: localizedTexts.games.mistakes,
			speed: localizedTexts.games.speed,
			errorRate: localizedTexts.games.errorRate,
			timeElapsed: localizedTexts.games.timeElapsed
		}
	};

	this.results = {
		keystrokes: 0,
		good_keystrokes: 0,
		points: 0,
		mistakes: 0
	};

	this.maxLives = this.lives
	this.resetGameVariables(true);
	this.problemWords = new Array();
	this.tooltips = new Array();
	isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
	this.lastStrokeTime = 0;
	this.invalidGameTime = 0;
	this.timeBetweenWords = 0;
},

processTimeBetweenLetters: function() {

	var now = new Date().getTime();
	
	if (this.lastStrokeTime > 0) {		// something was typed already
		
		var timeFromLastStroke = now - this.lastStrokeTime;

		if (timeFromLastStroke > 10000) {		// delay longer than 10 seconds between strokes (or from the start)
			this.invalidGameTime += timeFromLastStroke;
		}
	}
	else {
		this.invalidGameTime += now - this.startTime;	// time from start without any typing is also invalid
	}
		
	
	this.lastStrokeTime = new Date().getTime();
},

setKeyboard: function(params) {
	// Default params, could be override in games
	params = $.extend({
		'context': this,
		'isHomepage': this.isHomepage,
		'containerName': this.containerName,
		'notCatchCtrl': true,
		'notCatchAlt': false,
		'pauseSpecialKeys': {
			'R': this.restartGame
		},
	}, params);

	var _this = this;

	var acute = false; // carka
	var caron = false; // hacek
	var umlaut = false; // prehlaska
	var letterTranscripts = {
		// lower case
		'a': [ 'á', 'ǎ', 'ä' ],
		'e': [ 'é', 'ě', 'ë' ],
		'i': [ 'í', 'ǐ', 'ö' ],
		'o': [ 'ó', 'ǒ', 'ö' ],
		'u': [ 'ú', 'ǔ', 'ü' ],
		'y': [ 'ý', null, 'ÿ' ],
		'c': [ 'ć', 'č', null ],
		'd': [ null, 'ď', null ],
		'n': [ 'ń', 'ň', null ],
		'r': [ 'ŕ', 'ř', null ],
		's': [ 'ś', 'š', null ],
		't': [ null, 'ť', 'ẗ' ],
		'z': [ 'ź', 'ž', null ],
		// upper case
		'A': [ 'Á', 'Ǎ', 'Ä' ],
		'E': [ 'É', 'Ě', 'Ë' ],
		'I': [ 'Í', 'Ǐ', 'Ö' ],
		'O': [ 'Ó', 'Ǒ', 'Ö' ],
		'U': [ 'Ú', 'Ǔ', 'Ü' ],
		'Y': [ 'Ý', null, 'Ÿ' ],
		'C': [ 'Ć', 'Č', null ],
		'D': [ null, 'Ď', null ],
		'N': [ 'Ń', 'Ň', null ],
		'R': [ 'Ŕ', 'Ř', null ],
		'S': [ 'Ś', 'Š', null ],
		'T': [ null, 'Ť', 'T̈' ],
		'Z': [ 'Ź', 'Ž', null ]
	};

	var keyCodeEvents = {
		27: 'Esc',
		8: 'Backspace',
		32: 'Spacebar',
		13: 'Enter'
	};

	this.keyboardKeydownFunction = function(event) {
		// on homepage, we start the game only if the game is in the viewport
		if (params.isHomepage && !isElementInViewport($('#' + params.containerName))) {
			return;
		}

		// pokud jsem ve formulari (mam focus na textarea, input, button), tak taky nereflektovat ve hre
		if (!params['allowFormMode'] && $('input:focus, textarea:focus, button:focus').length > 0) {
			return;
		}

		if (params.notCatchCtrl && event.ctrlKey
			|| params.notCatchAlt && event.altKey)
			return;

		if (!event.key && event.keyCode >= 65 && event.keyCode <= 90) {
			event.key = String.fromCharCode(event.keyCode);
			if (!event.shiftKey) event.key = event.key.toLowerCase();
		} else if (!event.key || event.keyCode in keyCodeEvents) {
			event.key = keyCodeEvents[event.keyCode];
		}

		// CROSSPLATFORM DEAD KEYS HANDLING
		var isMac = navigator.appVersion.indexOf("Mac") != -1,
			isLinux = navigator.appVersion.indexOf("X11") != -1 || navigator.appVersion.indexOf("Linux") != -1,
			isMacDeadDown = isMac && event.originalEvent.keyCode === 187,
			isLinuxDeadDown = isLinux && event.originalEvent.keyCode === 191,
			isAnyDead = event.originalEvent.key === "Dead" // suppose only acute and caron dead keys will be used

		if (isMac || isLinux) {
			if (isMacDeadDown || isLinuxDeadDown || isAnyDead) {
				acute = caron = false
				if (!event.shiftKey)
					acute = true
				else
					caron = true
			}
		}

		no_propagate = false;

		if (!params.context.gameOver) {
			// Manage special keys
			if (params.context.gamePaused && event.key in params.pauseSpecialKeys) {
				params.pauseSpecialKeys[event.key].apply(params.context);
				no_propagate = true;
			} else if (event.key in params.specialKeys) {
				// EXECUTE LETTER FUNCTION
				params.specialKeys[event.key].apply(params.context, [event.key]);
			}
		}
		if (no_propagate || params.preventPropagation.indexOf(event.key) != -1) {
			// Stop propagation
			event.preventDefault();
			event.stopPropagation();
		}
	};

	this.keyboardKeypressFunction = function(event) {
		// on homepage, we start the game only if the game is in the viewport
		if (params.isHomepage && !isElementInViewport($('#'+params.containerName))) { return; }

		// pokud jsem ve formulari (mam focus na textarea, input, button), tak taky nereflektovat ve hre
		if (!params['allowFormMode'] && $('input:focus, textarea:focus, button:focus').length > 0) { return; }

		if((params.notCatchCtrl && !params.notCatchAlt) && (event.ctrlKey && event.altKey)){} // ALTGR (pokud je zakázán ctrl, tak altgr projde i přestože ctrl aktivuje - je povolena zkratka ctrl + alt)
		else if (params.notCatchCtrl && event.ctrlKey
			|| params.notCatchAlt && event.altKey)
			return;

		var wasPlaying = params.context.gamePlaying;

		if (event.key == 'DeadAcute') { acute = true; caron = umlaut = false; return; }
		if (event.key == 'DeadCaron') { caron = true; acute = umlaut = false; return; }
		if (event.key == 'DeadUmlaut') { umlaut = true; acute = caron = false; return; }
		if (event.key == 'Backspace' || event.key == 'Esc') { umlaut = acute = caron = false; }

		if (!event.key || event.keyCode == 32) {
			event.key = keyCodeEvents[event.keyCode];
		}

		// Manage letters
		if (event.charCode == 0) return;
		var letter = String.fromCharCode(event.charCode);
		if (acute && letter in letterTranscripts && letterTranscripts[letter][0]) {
			letter = letterTranscripts[letter][0];
			umlaut = acute = caron = false;
		}
		if (caron && letter in letterTranscripts && letterTranscripts[letter][1]) {
			letter = letterTranscripts[letter][1];
			umlaut = acute = caron = false;
		}
		if (umlaut && letter in letterTranscripts && letterTranscripts[letter][2]) {
			letter = letterTranscripts[letter][2];
			umlaut = acute = caron = false;
		}

		// ALWAYS RESET DEAD ON KEYPRESS
		acute = caron = false

		// Manage special letters
		if (letter in params.specialLetters) {
			params.specialLetters[letter].apply(params.context);
			return;
		} else if (params['letter']) {
			// EXECUTE LETTER FUNCTION
			params['letter'].apply(params.context, [letter]);
		}

		if (params.context.gamePlaying || params.context.gameStarting || wasPlaying) {
			// Stop propagation
			event.preventDefault();
			event.stopPropagation();
		}
	};
},

startWatchingKeyboard: function() {
	jQuery(document.body).on("keydown", this.keyboardKeydownFunction);
	jQuery(document.body).on("keypress", this.keyboardKeypressFunction);
},

stopWatchingKeyboard: function() {
	jQuery(document.body).off("keydown", this.keyboardKeydownFunction);
	jQuery(document.body).off("keypress", this.keyboardKeypressFunction);
},

tooltipsDraw: function() {
	this.tooltipsTimeouts = new Array();
	this.layers.tooltips_layer = new Kinetic.Layer();
	var t = this;
	// Show (add to layer) what should be visible
	for (var index = 0; index < Object.keys(this.c.tooltips).length; index++) {
		var key = Object.keys(this.c.tooltips)[index];
		this.tooltipDraw(key);
	}
	this.stage.add(this.layers.tooltips_layer);
},

tooltipDraw: function(key) {
	var t = this;
	var tooltip = this.c.tooltips[key];
	if (this.tooltips.hasOwnProperty(key)) {
		this.layers.tooltips_layer.add(this.tooltips[key]);
		// Set imediate hide after click
		this.tooltips[key].on('click', function() { t.tooltipHide(key) });
	}

},

tooltipsStart: function() {
	for (var index = 0; index < Object.keys(this.c.tooltips).length; index++) {
		var key = Object.keys(this.c.tooltips)[index];
		if (this.tooltips.hasOwnProperty(key)) this.tooltipShow(key);
	}
},

tooltipHide: function(tooltip, duration) {
	var t = this;
	var duration = (typeof duration !== 'undefined') ? duration : 0.5;

	if (this.tooltips.hasOwnProperty(tooltip) && this.c.tooltips.hasOwnProperty(tooltip)) {
		new Kinetic.Tween({
			node: this.tooltips[tooltip],
			opacity: 0,
			duration: duration
		}).play();
		if (isFirefox) this.tooltips[tooltip].visible(false);
		if (this.c.tooltips[tooltip].hasOwnProperty('reload')) {
			window.clearTimeout(this.tooltipsTimeouts[tooltip]);
			this.tooltipsTimeouts[tooltip] = window.setTimeout(function() {
				t.tooltipShow(tooltip);
			}, this.c.tooltips[tooltip]['reload']*1000);
		}
	}
},

tooltipShow: function(tooltip) {
	var t = this;
	if (this.tooltips.hasOwnProperty(tooltip) && this.c.tooltips.hasOwnProperty(tooltip)) {
		new Kinetic.Tween({
			node: this.tooltips[tooltip],
			opacity: 1,
			duration: 0.5
		}).play();
		if (isFirefox) this.tooltips[tooltip].visible(true);
		if (this.c.tooltips[tooltip].hasOwnProperty('timeout'))
			window.setTimeout(function() {
				t.tooltipHide(tooltip);
			}, this.c.tooltips[tooltip]['timeout']*1000);
	}
},

// Clean all mess
resetGameEnvironment: function() {
	this.gameDisplayed = false;
	this.gamePlaying = false;
	jQuery(document.body).off("keydown", this.keyboardKeydownFunction);
	jQuery(document.body).off("keypress", this.keyboardKeypressFunction);
	jQuery("#snippet-game-keyboard").finish()
		//.animate({ top: "0px"}, 100)
		.slideUp();
},

reloadAfterPlayTexts: function() {
	$.ajax(this.l.reloadAfterPlayTextsUrl, {
		'data': [],
		'dataType': 'json',
		'method': 'post',
		'success': function(data, status) {
			for (var stars=0; stars<=3; ++stars) {
				$('#afterplayHeader-'+stars).text(data.texts[stars].header);
				$('#afterplayStarComment-'+stars).text(data.texts[stars].starComment);
				$('#afterplayMotivation-'+stars).text(data.texts[stars].motivation);
			}
		 },
		'error': function(jqXHR, status) {
		}
	});
},
reloadPlayerXpInfo: function() {

	const t = this;

	$.ajax(this.l.reloadPlayerXpInfoUrl, {
		'data': [],
		'dataType': 'json',
		'method': 'post',
		'success': function(data, status) {
			t.xpScreenInfo = data['xpScreenInfo'];
		 },
		'error': function(jqXHR, status) {
		}
	});
},

genericPauseGame: function() {
	if (this.gamePaused) {
		// Action: resume
		this.gamePaused = false;

		var difference = new Date().getTime() - this.startPauseTime;
		this.gamePausedTime += difference;

		this.layers.pause_layer.hide();
		jQuery(document.body).on("keypress", this.keyboardKeypressFunction);
		jQuery("#snippet-game-keyboard").finish()
			//.animate({top: "0px"}, 500)
			.slideUp();
	} else {
		// Action: pause
		this.gamePaused = true;

		this.startPauseTime = new Date().getTime();

		this.layers.pause_layer.show();
		jQuery(document.body).off("keypress", this.keyboardKeypressFunction);	// ne this.stopWatchingKeyboard(), protoze by se neslo pomoci Esc vratit z pauzy ke hre
		jQuery("#snippet-game-keyboard").finish()
			//.animate({top: "-250px"}, 500)
			.slideDown();
	}
},


// cas hrani teto hry (bez neplatneho casu, kdy hrac nepsal)
getTypingTime: function() {
	if (this.lastStrokeTime == 0) {		// no stroke at all – the player just started the game, but did not type
		return 0;
	}
	else {
		return this.lastStrokeTime - this.startTime - this.invalidGameTime - this.timeBetweenWords;		// we subtract too long delays between strokes (which includes pauses too)
	}
},


// cas od startu hry (at uz hrac psal, nebo ne)
// zasadni rozdil oproti getTypingTime() je, ze tady neodecitame this.invalidGameTime!
getGameTime: function() {
	return new Date().getTime() - this.startTime;
},

getFormattedTime: function() {
	var gameTime = Math.floor(this.getGameTime()/1000);
	var minutes = Math.floor(gameTime / 60);
	var seconds = gameTime % 60;
	var secondsString = (seconds < 10) ? '0'+seconds : seconds;

	return minutes+':'+secondsString;
},

getRemainingTime: function() {
	if(!this.c.timeLimit) return 0;

	return Math.max(0, this.c.timeLimit -
		this.getGameTime());
},

formatTime: function(time) {
	time = parseInt(time);
	time = Math.floor(time/1000);
	var minutes = Math.floor(time / 60);
	var seconds = time % 60;
	var secondsString = (seconds < 10) ? '0'+seconds : seconds;

	return minutes+':'+secondsString;
},

getSpeed: function() {
	if (this.getTypingTime() === 0) return 0;
	if (this.gameFinalSpeed > 0) {
		return this.gameFinalSpeed;	// don't compute the speed after the game ended and this.gameFinalSpeed variable was set (because time is still running)
	}

	if (this.c.timeLimit) {
		return Math.ceil(this.getAllStrokes() * 60*1000 / this.getGameTime());
	} else {
		return Math.ceil(this.getAllStrokes() * 60*1000 / this.getTypingTime());
	}
},

getCleanSpeed: function(penaltyStrokesForMistake = 10) {
	if (this.getTypingTime() === 0) return 0;
	if (this.gameFinalCleanSpeed > 0) {
		return this.gameFinalCleanSpeed;	// don't compute the speed after the game ended and this.gameFinalCleanSpeed variable was set (because time is still running)
	}

	if (this.c.timeLimit) {
		return Math.ceil((this.getAllStrokes() - this.getTyposCount() * penaltyStrokesForMistake) * 60*1000 / this.getGameTime());
	} else {
		return Math.ceil((this.getAllStrokes() - this.getTyposCount() * penaltyStrokesForMistake) * 60*1000 / this.getTypingTime());
	}

},

getSpeedClass: function() {
	var speed = this.getSpeed().toFixed(1);
	if(speed < 33) return "slow";
	else if(speed < 66) return "medium";
	else return "fast";
},

getAccuracy: function() {
	if (this.results.keystrokes === 0) return 0;
	return 100 * this.results.good_keystrokes / this.results.keystrokes;
},

getGoodStrokes: function() {
	return this.results.good_keystrokes;
},

getAllStrokes: function() {
	return this.results.keystrokes;
},

getTyposCount: function() {
	return this.results.mistakes;
	//return this.results.keystrokes - this.results.good_keystrokes;
},

getErrorRate: function() {
	if (this.results.keystrokes === 0) return 0;
	return 100 * (this.results.keystrokes - this.results.good_keystrokes) / this.results.keystrokes;
},

removeStartLives: function(){
	if (this.c.livesMissing !== undefined){
		var t = this
		this.lives -= this.c.livesMissing;
		if(this.lives <= 0){
			this.lives = 0;
			this.endGame();
		}
		for (var i = 1; i <= this.c.livesMissing; i++){
			var node = this.liveSymbol[this.liveSymbol.length - i];
			node.setImage(t.deadLiveSymbolObj);
		}
		this.layers.lives_layer.draw();
	} else if(this.c.remainingLives !== undefined && this.c.remainingLives < this.lives){
		var t = this
		this.lives = this.c.remainingLives;
		if(this.lives <= 0){
			this.lives = 0;
			this.endGame();
		}
		for (var i = this.c.remainingLives; i < this.liveSymbol.length; i++){
			var node = this.liveSymbol[i];
			node.setImage(t.deadLiveSymbolObj);
		}
		this.layers.lives_layer.draw();
	}
},

removeLive: function() {

	if(this.c.gameEndCondition === this.GAME_CONDITION_TIME)
		return;

	this.lives--;
	if (this.lives <= 0) {
		this.lives = 0; // JS is asynchronous - failsave
		this.endGame();
	}
	var t = this;
	var node = this.liveSymbol[this.lives];
	new Kinetic.Tween({
		node: node,
		duration: 0.5,
		opacity: this.g.lives.deadOpacity,
		onFinish: function() {
			node.setImage(t.deadLiveSymbolObj);
			new Kinetic.Tween({
				node: node,
				duration: 0.5,
				opacity: 1,
			}).play();
		}
	}).play();
},

doErrorFlash: function() {

	if (!this.showErrorFlash) return;

	this.errorFlash.setOpacity(0.5);
	this.errorFlash.draw();
	new Kinetic.Tween({
		node: this.errorFlash,
		opacity: 0,
		duration: 0.5,
	}).play();
},

showSuccessFlash: function() {
	this.successFlash.setOpacity(0.5);
	this.successFlash.draw();
	new Kinetic.Tween({
		node: this.successFlash,
		opacity: 0,
		duration: 1,
	}).play();
},

constructArrow: function(fromx, fromy, tox, toy, strokeColor){
	if (typeof(strokeColor) == "undefined") strokeColor = this.common.colors.black;
	var headlen = 20;   // how long you want the head of the arrow to be, you could calculate this as a fraction of the distance between the points as well.
	var angle = Math.atan2(toy-fromy,tox-fromx);

	return new Kinetic.Line({
		points: [fromx, fromy, tox, toy, tox-headlen*Math.cos(angle-Math.PI/6),toy-headlen*Math.sin(angle-Math.PI/6),tox, toy, tox-headlen*Math.cos(angle+Math.PI/6),toy-headlen*Math.sin(angle+Math.PI/6)],
		stroke: strokeColor,
		shadowBlur: 4,
		shadowOpacity: 0.5,
		shadowColor: strokeColor
	});
},

drawResultsSlider: function(layer, points, error) {

	var resultsRect = new Kinetic.Rect({
		//x: this.g.sidebarWidth/2 - 8/2,
		//y: this.resultsBarTop - 4,
		x: -2,
		y: 14,
		stroke: this.common.colors.pointBar.stroke,
		strokeWidth: 2.5,
		height: 25,
		width: this.resultsBarWidth + 4,
		cornerRadius: 12,
		fill: this.common.colors.pointBar.fill
	});
	this.resultsRect = resultsRect;

	var limitLine1 = new Kinetic.Line({
		points: [0,0, 0, resultsRect.getHeight()],
		stroke: '#dadada',
		strokeWidth: 1
	});
	var limitLine2 = limitLine1.clone();
	var limitLine3 = limitLine1.clone();
	limitLine1.move({x: resultsRect.getX() + resultsRect.getWidth()/4, y: resultsRect.getY()});
	limitLine2.move({x: resultsRect.getX() + resultsRect.getWidth()/2, y: resultsRect.getY()});
	limitLine3.move({x: resultsRect.getX() + resultsRect.getWidth()*3/4, y: resultsRect.getY()});

	if((points && this.c.targetPoints != 0) || error)
		layer.add(resultsRect).add(limitLine1).add(limitLine2).add(limitLine3);

	if(points) {
		this.pointBar = {};
		this.pointBar.box = new Kinetic.Group({
			x: -1,
			y: resultsRect.getY(),
		});
		this.pointBar.rect = new Kinetic.Rect({
			x: -1,
			y: 0,
			width: 30,
			cornerRadius: 12,
			height: 25,
			fill: this.g.levelColor
		});
		this.pointBar.text = new Kinetic.Text({
			y: this.pointBar.rect.getY() + 6,
			x: 5,
			fontSize: 14,
			fontFamily: 'Open Sans, Arial',
			fontStyle: 'bold',
			fill: this.common.colors.pointBar.text,
			text: '0%'
		});
		this.pointBar.box.add(this.pointBar.rect).add(this.pointBar.text);
		if (this.c.targetPoints != 0) layer.add(this.pointBar.box);
	}

	if(error) {
		this.errorSlider = {};
		this.errorSlider.box = new Kinetic.Group({
			//x: this.resultsBarWidth,
			x: 0,
			y: resultsRect.getY()
		});
			this.errorSlider.line = new Kinetic.Rect({
				x: -2,
				y: resultsRect.getHeight(),
				width: 4,
				height: 6,
				fill: 'white'
			});
			this.errorSlider.rect = new Kinetic.Rect({
				x: -20,
				y: resultsRect.getHeight() + this.pointsSlider.line.getHeight(),
				width: 40,
				height: 18,
				stroke: 'white',
				strokeWidth: 1.5,
				cornerRadius: 3,
				fill: '#f78fa6'
			});
			this.errorSlider.text = new Kinetic.Text({
				y: this.pointsSlider.rect.getY() + 3,
				fontSize: 14,
				fontFamily: 'Open Sans, Arial',
				fontStyle: 'bold',
				fill: '#444444',
				text: '0%'
			});
			this.errorSlider.text.setX(this.errorSlider.rect.getX() + this.errorSlider.rect.getWidth()/2 - this.errorSlider.text.getWidth()/2);
			this.errorSlider.box.add(this.errorSlider.rect).add(this.errorSlider.line).add(this.errorSlider.text);
		layer.add(this.errorSlider.box);
	}
},

// @TODO tohle predelat! (vytvorit zvlastni parametr v nastaveni)
isFirstGameOfType: function(){
	return this.c.roundId == 1 ||		// speed test
			this.c.roundId == 3 ||		// homepage skol
			this.c.roundId == 4 ||		// verejny test psani
			this.c.roundId == 11 ||		// test v tlacence
			this.c.roundId == 12 ||		// shooter v tlacence
			this.c.roundId == 12379 ||
			this.c.roundId == 12382 ||
			this.c.roundId == 12384 ||
			this.c.roundId == 12386;
},

getStartGameTipText: function(){
	if(!this.t.startGameTip) return "";
	var tip = this.t.startGameTip;
	this.t.startGameTip = '';
	return tip;
},

drawStartGameTip: function(firstgame){
	var tipText = this.getStartGameTipText();
	if(tipText.length < 1) return;
	this.separatorUp = new Kinetic.Rect({
		height: 0.2,
		x: -70,
		y: 145,
		width: 735,
		fill: this.common.colors.startTip.separator,
	});
	this.layers.message_layer.add(this.separatorUp);

	this.startTipText = new Kinetic.Text({
		text: tipText,
		fontSize: 15,
		fontFamily: 'Open Sans, Arial',
		fontWeight: 600,
		fill: this.common.colors.startTip.text,
		align: 'left',
		x: 90,
		width: 500,
		lineHeight: 1.3
	});

	this.startTipText.y(145 + ((130 - this.startTipText.height()) / 2));
	this.layers.message_layer.add(this.startTipText);

	this.exclMarkSeparator = new Kinetic.Rect({
		height: this.startTipText.height() + 10,
		x: 60,
		width: 3,
		fill: '#e9e9e9',
		y: this.startTipText.y() - 5
	});
	this.layers.message_layer.add(this.exclMarkSeparator);

	this.exclMark = new Kinetic.Rect({
		height: 40,
		width: 40,
		x: -10,
		y: this.exclMarkSeparator.y() + ((this.exclMarkSeparator.height() - 40) / 2),
		fill: startTipMarkColor,
		opacity: this.g.opacity,
		cornerRadius: 2,
		stroke: '#e9e9e9',
		strokeWidth: 3,
	});
	this.layers.message_layer.add(this.exclMark);

	this.exclMarkText = new Kinetic.Text({
		text: '!',
		height: 40,
		width: 40,
		x: 6,
		y: this.exclMark.y() + 10,
		fill: '#FFFFFF',
		fontSize: 25
	});
	this.layers.message_layer.add(this.exclMarkText);


	this.separatorDown = this.separatorUp.clone();
	this.layers.message_layer.add(this.separatorDown);

	this.separatorUp.y(this.separatorUp.y() - 140);
	this.startTipText.y(this.startTipText.y() - 130);
	this.exclMarkSeparator.y(this.exclMarkSeparator.y() - 130);
	this.exclMark.y(this.exclMark.y() - 130);
	this.exclMarkText.y(this.exclMarkText.y() - 130);
	this.separatorDown.y(this.separatorUp.y() + 150);
},

addMessageLayer: function() {
	var firstgame = this.isFirstGameOfType();
	this.layers.message_layer = new Kinetic.Layer();
	// since this text is inside of a defined area, we can center it using
	// align: 'center'
	this.message1Text = new Kinetic.Text({
		text: this.t.startText1,
		fontSize: this.g.message1.fontSize,
		fontFamily: this.g.message1.fontFamily,
		fontStyle: this.g.message1.fontStyle,
		fill: this.g.message1.color,
		width: this.g.message1.width,
		padding: 10,
		lineHeight: 1.2,
		align: 'center',
		y: -90
	});

	if (this.t.startText11) {
		this.message11Text = new Kinetic.Text({
			text: this.t.startText11,
			fontSize: this.g.message11.fontSize,
			fontFamily: this.g.message11.fontFamily,
			fontStyle: this.g.message11.fontStyle,
			fill: this.g.message11.color,
			width: this.g.message11.width,
			padding: 10,
			align: 'center',
			y: this.message1Text.getHeight()
		});
		message11Height = this.message11Text.getHeight();
	}
	else {
		message11Height = 0;
	}


	this.message2Text = new Kinetic.Text({
		text: !firstgame ? this.t.startText2.replace('\n\n', '          ') : this.t.startText2,
		fontSize: !firstgame ? this.g.message2.fontSize - 5 : this.g.message2.fontSize,
		fontFamily: this.g.message2.fontFamily,
		fontStyle: this.g.message2.fontStyle,
		fill: this.g.message2.color,
		width: this.g.message2.width,
		padding: 10,
		align: 'center',
		//x: !firstgame ? 320 : 200,
		y: firstgame ? this.message1Text.getHeight() + message11Height - 25 : 220 //+ 40
	});


	this.messageRect = new Kinetic.Rect({
		stroke: this.g.message1.borderColor,
		strokeWidth: 6,
		width: this.g.message1.width,
		height: this.message1Text.getHeight() + this.message2Text.getHeight() + message11Height,
		shadowColor: this.common.colors.black,
		shadowBlur: 10,
		shadowOffset: [10, 10],
		shadowOpacity: 0.4,
		cornerRadius: 5,
		fill: this.g.message1.fill
	});

	this.drawStartGameTip(firstgame);

	this.layers.message_layer
		//.add(this.messageRect)
		.add(this.message1Text);

	if (this.t.startText11) {
		this.layers.message_layer.add(this.message11Text)
	}

	this.layers.message_layer.add(this.message2Text);
	this.layers.message_layer
		.setX(this.stage.getWidth()/2 - this.messageRect.getWidth()/2)
		.setY(this.stage.getHeight()/2 - this.messageRect.getHeight()/2);
	this.stage.add(this.layers.message_layer);
},

addPauseLayer: function() {
	this.layers.pause_layer = new Kinetic.Layer();
	var pauseText = new Kinetic.Text({
		text: this.t.pause,
		fontSize: this.g.pause.fontSize,
		fontFamily: this.g.pause.fontFamily,
		fontStyle: this.g.pause.fontStyle,
		fill: this.g.pause.color,
		width: this.g.pause.width,
		padding: 10,
		align: 'center'
	});


	if(this.publicContestId && this.publicContestPlayerLives == 1) {
		pauseTextVar = this.t.pauseText.split(/\r?\n/)[0]
	} else {
		pauseTextVar = this.t.pauseText
	}

	var pauseTextDescription = new Kinetic.Text({
		y: pauseText.getHeight(),
		text: pauseTextVar,
		fontSize: this.g.pauseDescription.fontSize,
		fontFamily: this.g.pauseDescription.fontFamily,
		fontStyle: this.g.pauseDescription.fontStyle,
		fill: this.g.pauseDescription.color,
		width: this.g.pause.width,
		padding: 10,
		align: 'center'
	});
	var pauseRect = new Kinetic.Rect({
		//stroke: this.g.message1.borderColor,
		//strokeWidth: 0, //6
		width: this.g.pause.width,
		height: pauseText.getHeight() + pauseTextDescription.getHeight(),
		shadowColor: 'black',
		shadowBlur: 10,
		shadowOffset: [10, 10],
		shadowOpacity: 0.4,
		cornerRadius: 2, //5
		//fill: this.g.pause.fill
	});
	this.layers.pause_layer.add(pauseRect).add(pauseText).add(pauseTextDescription);
	this.layers.pause_layer.setX(this.stage.getWidth()/2 - pauseRect.getWidth()/2);
	this.layers.pause_layer.setY((this.stage.getHeight() - pauseRect.getHeight()) / 2);
	//this.layers.pause_layer.setY(this.stage.getHeight()/3 - pauseRect.getHeight()/2);
	this.stage.add(this.layers.pause_layer);
	this.layers.pause_layer.hide();
},

addCountdownLayer: function(x, y) {
	this.layers.countdown_layer = new Kinetic.Layer({
		x: x,
		y: y
	});

	this.countdownCircle = new Kinetic.Wedge({
		radius: this.g.countdownCircle.radius,
		angleDeg: 0,
		fill: this.g.countdownCircle.color,
		rotationDeg: -90,
		//shadowColor: this.g.countdownCircle.color,
		//shadowBlur: 10,
		//shadowOpacity: 0.8,
		//clockwise: true
	});
	var countdownCircleCenter = new Kinetic.Circle({
		radius: this.g.countdownCircle.radius - this.g.countdownCircle.border,
		fill: this.g.allBackgroundColor,
	});

	this.countdownText = new Kinetic.Text({
		fill: this.g.countdownCircle.color,
		fontFamily: this.g.countdownCircle.fontFamily
	});

	this.layers.countdown_layer.add(this.countdownCircle).add(countdownCircleCenter).add(this.countdownText);
	this.stage.add(this.layers.countdown_layer);
	this.layers.countdown_layer.hide();

	// Countdown function
	var t = this;
	this.countdownCountingStarted = false;
	this.countdownCountingTime = this.c.countdownStart;
	this.countdownCounting = function() {
		if (!t.countdownCountingStarted) {
			t.layers.countdown_layer.show();
			new Kinetic.Tween({
				node: t.countdownCircle,
				duration: t.c.countdownStart,
				angleDeg: 360
			}).play();
			t.countdownCountingStarted = true;
		}

		t.countdownText.setText(t.countdownCountingTime);
		t.countdownText.setFontSize(t.g.countdownCircle.radius * 0.7);
		t.countdownText.setX(-t.countdownText.getWidth() / 2);
		t.countdownText.setY(-t.countdownText.getHeight() / 2 + 2);

		var factor = 2.2;
		new Kinetic.Tween({
			node: t.countdownText,
			duration: 1,
			x: t.countdownText.getX()*factor,
			y: t.countdownText.getY()*factor,
			fontSize: t.countdownText.getFontSize()*factor
		}).play();

		t.countdownCountingTime -= 1;
		if (t.countdownCountingTime >= 0) setTimeout(t.countdownCounting, 1000);
	}
},

addLivesLayer: function() {
	this.layers.lives_layer = new Kinetic.Layer();

	this.liveSymbol = Array();

	this.liveSymbolObj = new Image();
	this.deadLiveSymbolObj = new Image();
	var line = 0;
	var onLine = 0;
	var lastLineOffset = 0;
	for (var i = 0; i < this.c.lives; i++) {
		if (onLine == this.g.lives.perLine) {
			onLine = 0;
			line += 1;
			// Test for last line
			if (i + this.g.lives.perLine > this.c.lives) {
				lastLineOffset = (this.g.lives.perLine + i - this.c.lives)/2;
			}
		}
		//var position = (lastLineOffset + onLine)/(this.g.lives.perLine - 1);
		this.liveSymbol[i] = new Kinetic.Image({
			//x: this.g.lives.offset + (this.g.sidebarWidth - 2*this.g.lives.offset)*position - 20,
			x: this.g.lives.offset*(i+1) - 20,
			y: 30*line + 3, //30
			image: this.liveSymbolObj,
			width: 36,
			height: 35,
			opacity: 1
		});
		this.layers.lives_layer.add(this.liveSymbol[i]);
		onLine += 1;
	}
	var t = this;
	this.liveSymbolObj.onload = function() { t.layers.lives_layer.draw(); };

	var heartFile = 'heart.png';
	var heartWhiteFile = 'heart_white.png';

	this.liveSymbolObj.src = this.l.imgUrl + heartFile;
	this.deadLiveSymbolObj.onload = function() { t.layers.lives_layer.draw(); };
	this.deadLiveSymbolObj.src = this.l.imgUrl + heartWhiteFile;
	this.stage.add(this.layers.lives_layer);
	this.lives = this.c.lives;
	this.maxLives = this.lives
},

drawLivesResult: function(won, gameObject, afterPlay){
	const heartTemplate = $(afterPlay.find('.live-svg').clone());
	//var cssClass = heartTemplate.attr('class');
	//heartTemplate.attr('class', cssClass.replace('hidden', '').replace('live-svg', ''));
	heartTemplate.removeClassSVG('hidden live-svg')
	this.heartCount = 0;


	if(this.lives === undefined){
		const heart = $(heartTemplate.clone());
		heart.css({
			width: 25,
			height: 25,
			fill: '#000',
			position: 'absolute',
			top: 'calc(50% - 5px)',
			left: 'calc(50% - 12.5px)',
			opacity: 0
		});
		heart.attr('id', 'heart-1');
		heart.appendTo(afterPlay.find('.lives-container'));
		this.heartCount = 1;
	} 
	else
	{
		let currentHeart = 1;
		let heartsRow2Count = Math.ceil(this.c.lives / 2);
		
		if(this.c.lives == 2) heartsRow2Count++;

		const heartsRow2 = $('<div>');
		heartsRow2.css({
			position: 'absolute',
			bottom: 12,
			left: '50%',
			transform: 'translateX(-50%)',
			textAlign: 'center',
			whiteSpace: 'nowrap'
		});

		for (var i = 1; i <= heartsRow2Count; i++)
		{
			let heart = $(heartTemplate.clone());
	
			heart.css({
				width: 17,
				height: 13,
				fill: currentHeart <= this.lives ? '#E54027' : '#C2C2C2',
				opacity: 0,
				marginRight: 2,
				marginLeft: 2,
				overflow: 'visible'
			});
			heart.attr('id', 'heart-' + currentHeart);
			heart.appendTo(heartsRow2);
			currentHeart++;
		}

		heartsRow2.appendTo(afterPlay.find('.lives-container'));
		var heartsRow1Count = this.c.lives - heartsRow2Count;
		if(heartsRow1Count > 0){
			var heartsRow1 = $('<div>');
			heartsRow1.css({
				position: 'absolute',
				bottom: 30,
				left: '50%',
				transform: 'translateX(-50%)',
				textAlign: 'center',
				whiteSpace: 'nowrap'
			});
			for (var i = 1; i <= heartsRow1Count; i++){
				var heart = $(heartTemplate.clone());
				heart.css({
					width: 17,
					height: 13,
					fill: currentHeart <= this.lives ? '#E54027' : '#C2C2C2',
					opacity: 0,
					marginRight: 2,
					marginLeft: 2,
					overflow: 'visible'
				});
				heart.attr('id', 'heart-' + currentHeart);
				heart.appendTo(heartsRow1);
				currentHeart++;
			}
			heartsRow1.appendTo(afterPlay.find('.lives-container'));
		}
	}
},

loadNumber: function(obj, delay){
	var t = this;
	var max = obj.data('maximum');
	var current = parseInt(obj.text());
	if (current >= max){
		obj.text(max);
		return;
	}
	obj.text(current + 1);
	setTimeout(function(){
		t.loadNumber(obj, delay);
	}, delay);
},

showHearts: function(index){
	var t = this;
	var $heart = $('#gameCanvas').find('#heart-' + index);
	if($heart.length < 1) return;
	$heart.css({
		opacity: 1
	});
	setTimeout(function(){
		t.showHearts(index + 1);
	}, 800)
},

getPlayerRank: function(){
	return {
		mistakes: 1,
		speed: 3,
		betterThan: 75
	};
},

starsAnimation: function(i, won){
	var t = this;

	if(i >= 4){
		$('#gameCanvas').find('.star-comment').removeClassSVG('opacity-0');
		var $active = $('.round.active');
		if($active.data('currentstars') < this.getStars(won)) {
		 	var newStars = parseInt($('.update-stars').text()) + this.getStars(won) - $active.data('currentstars');
		 	$active.data('currentstars', this.getStars(won)).removeClassSVG('stars-' + $active.data('currentstars')).addClassSVG('stars-' + this.getStars(won));
		 	$('.update-stars').text(newStars);
		 	if(newStars > 0) $('.star-span').removeClassSVG('hidden');

		 	var starText = this.getStars(won) == 1 ? $active.data('1starlabel') : $active.data('morestarslabel');
		 	$active.attr('aria-label', $active.data('labelwithoutstars') + ', ' + this.getStars(won) + ' ' + starText);
		}
		return
	}
	$('#gameCanvas').find('#star-'+i).removeClassSVG('opacity-0');
	setTimeout(function(){
		t.starsAnimation(i + 1, won);
	}, 500);
},

updateAccuracyLevelData: function(goodKeystrokes) {
	var currentMax = parseInt($('.maxLettersTyped').text());
	if (goodKeystrokes > currentMax) {
		$('.maxLettersTyped').text(goodKeystrokes);
	}

	var currentAttemptCount = parseInt($('.attemptCount').text());
	$('.attemptCount').text(currentAttemptCount + 1);
},

updateContestData: function(results) {
	var secondsToEnd = parseInt($('.contestEndTime').attr('data-secondsToEnd'));
	if (secondsToEnd <= 0) return;

	// update attempts
	var currentAttemptCount = parseInt($('.attemptCount').text());
	$('.attemptCount').text(currentAttemptCount + 1);	

	if (results.won) {
		var currentWonAttemptCount = parseInt($('.wonAttemptCount').text());
		$('.wonAttemptCount').text(currentWonAttemptCount + 1);	
	}


	// update best game info
	var bestGameSpeed = parseInt($('.bestGameSpeed').text());
	if (results.playerSpeed > bestGameSpeed) {
		$('.bestGameSpeed').text(results.playerSpeed);
		$('.bestGameTypos').text(results.mistakeCount);
	} 
	
},

declineLives: function(number){
	switch(number){
		case 1:
			return localizedTexts.games.oneLife;
			break;
		case 2:
			return localizedTexts.games.twoLife;
			break;
		case 3:
			return localizedTexts.games.threeLife;
			break;
		case 4:
			return localizedTexts.games.fourLife;
			break;
		default:
			return number + ' ' + localizedTexts.games.numberLifes;
			break;
	}
},

useOtherPlayersResults: function(afterPlay, mistakeCount, playerSpeed){
	if (!otherPlayersResults) return;		//@TODO otresne globalni, predelat!

	for(var prop in otherPlayersResults){
		otherPlayersResults[prop] = parseInt(otherPlayersResults[prop]);
	}

	//ADJUST OTHER PLAYERS' RESULTS START
	if(otherPlayersResults.averageMistakes === undefined || otherPlayersResults.averageMistakes === null)
		otherPlayersResults.averageMistakes = mistakeCount;
	otherPlayersResults.averageMistakes = (otherPlayersResults.averageMistakes * otherPlayersResults.otherGamesPlayed + mistakeCount) / (otherPlayersResults.otherGamesPlayed + 1);
	if(otherPlayersResults.leastMistakes === undefined || otherPlayersResults.leastMistakes === null || otherPlayersResults.leastMistakes > mistakeCount)
		otherPlayersResults.leastMistakes = mistakeCount;
	if(otherPlayersResults.averageSpeed === undefined || otherPlayersResults.averageSpeed === null)
		otherPlayersResults.averageSpeed = playerSpeed;
	otherPlayersResults.averageSpeed = (otherPlayersResults.averageSpeed * otherPlayersResults.otherGamesPlayed + playerSpeed) / (otherPlayersResults.otherGamesPlayed + 1);
	if(otherPlayersResults.bestSpeed === undefined || otherPlayersResults.bestSpeed === null || otherPlayersResults.bestSpeed < playerSpeed)
		otherPlayersResults.bestSpeed = playerSpeed;
	otherPlayersResults.otherGamesPlayed = otherPlayersResults.otherGamesPlayed + 1;
	//ADJUST OTHER PLAYERS' RESULTS END

	if(mistakeCount > otherPlayersResults.averageMistakes){
		// afterPlay.find('.mistakes-number').addClass('text-orange');
		afterPlay.find('.mistakes-arc').addClassSVG('fill-orange');
	}
	afterPlay.find('.average-mistakes-text').text(round(otherPlayersResults.averageMistakes, 1).toString().replace('.', ','));


	afterPlay.find('.player-rank-mistakes').text(round(otherPlayersResults.leastMistakes < mistakeCount ? otherPlayersResults.leastMistakes : mistakeCount, 0));

	if(mistakeCount <= otherPlayersResults.leastMistakes){
		afterPlay.find('.rank-crown-mistakes').addClass('fill-green');
		afterPlay.find('.player-rank-mistakes').addClass('text-green')
	}
	else
		afterPlay.find('.rank-crown-mistakes').addClass('fill-gray2');

	afterPlay.find('.average-speed-text').text(round(otherPlayersResults.averageSpeed, 0));
	afterPlay.find('.player-rank-speed').text(round(otherPlayersResults.bestSpeed > playerSpeed ? otherPlayersResults.bestSpeed : playerSpeed, 0));
	if(playerSpeed >= otherPlayersResults.bestSpeed){
		afterPlay.find('.rank-crown-speed').addClass('fill-green');
		afterPlay.find('.player-rank-speed').addClass('text-green')
	}
	else
		afterPlay.find('.rank-crown-speed').addClass('fill-gray2');
},


getFormattedMistakes: function(mistakes, gameTypeId, afterPlaySettings, won) {

	if (!this.l.getFormattedMistakesUrl) { return; }


	//If no mistakes
	if(mistakes.length == 0) 
	{
		setTimeout(() => {
			$('.link-showMistakes').remove();
			$('.link-hideMistakes').remove();
		}, 100);

		return;
	}


	setTimeout(() => 
	{
		$('.link-showMistakes').show();
		$('.link-hideMistakes').hide();
	}, 100);
	

	if(gameTypeId != 2) 
	{
		$.ajax(this.l.getFormattedMistakesUrl, {
			'data': {
				'mistakes': mistakes,
				'gameTypeId': gameTypeId,
			},
			'dataType': 'json',
			'method': 'post',
			'success': function (data) 
			{
				//If no mistakes
				if(data.formattedMistakes == null) 
				{
					$('#afterPlay-screen').show();
  					$('#mistakes-table').hide();

					$('.link-showMistakes').remove();
					$('.link-hideMistakes').remove();
				}


				$('#mistakes-table-body').append(data.formattedMistakes);

				$('.link-showMistakes').show();

				$('#mistakes-table-body').show();
				$('.loading-spinner-green').hide();

			},
			'error': function (jqXHR, status, errorThrown) {
				var errorData = {'source': 'getFormattedMistakes', 'status': status, 'errorThrown': errorThrown, 'responseText': jqXHR.responseText, 'attempts': this.attempts};
				$.ajax({
					method: "POST",
					url: errorLogUrl,
					data: errorData
				});
			}
		});
	}
	else 
	{
		setTimeout(() => 
		{
			$('.third-col').hide();
			$('.alternativeText').each((index, element) => {
				$(element).text($(element).attr('data-alternativeText'));
			});

			mistakes.forEach((mistake, index) => 
			{		
				$('#mistakes-table-body').append(
					'<tr><td class="font-weight-600 text-color-red">' + mistake.letter + '</td><td>' + mistake.mistakes + '</td></tr>'
				);
			});

			$('#mistakes-table-body').show();
			$('.loading-spinner-green').hide();

		}, 100);	
	}

},

/**
 * Shows results after the game (fills in #afterPlayContent div with game data).
 */
showResults: function(results, gameObject) {
	
	const afterPlay = $($('#afterPlayContent').clone(true));

	if(gameObject['canShowXpInfo'] == true) 
	{
		const xpInfo = gameObject['xpScreenInfo'];
	
		if(xpInfo['week']['object']['shouldBeUpdated'] == true)
		{
			afterPlay.find('#rewardsScreen').show();
			afterPlay.find('#afterPlay-screen').hide();

			setTimeout(() => 
			{
				this.updateWeeklyReward(afterPlay, xpInfo['week']);
				this.updateDayStreak(afterPlay, xpInfo['streak']);
			}, 150);

			const rewardsToAfterPlayTime = 5500;
			setTimeout(() => 
			{
				$('#rewardsScreen').hide();
				$('#afterPlay-screen').fadeIn(300);

			}, rewardsToAfterPlayTime);
		

			setTimeout(() => 
			{
				this.updateXPInfo(afterPlay, xpInfo, results);
			}, rewardsToAfterPlayTime + 500);
			
		}
		else 
		{
			afterPlay.find('#rewardsScreen').hide();
			afterPlay.find('#afterPlay-screen').show();

			setTimeout(() => 
			{
				this.updateXPInfo(afterPlay, xpInfo, results);
			}, 500);
		}
	} 
	else 
	{
		afterPlay.find('#rewardsScreen').hide();
		afterPlay.find('#afterPlay-screen').show();
	}


    var won = results.won;
	var playerRank = results.playerRank;
	var mistakeCount = results.mistakeCount;
	var playerSpeed = results.playerSpeed;


	//MISTAKES START
	this.getFormattedMistakes(results.mistakes, results.gameTypeId, afterPlaySettings, won);

	afterPlay.find('.mistakes-number').attr('data-maximum', mistakeCount);
	afterPlay.find('.mistakes-number').text(this.allowAnimations ? 0 : mistakeCount);
	switch(mistakeCount){
		case 1:
			afterPlay.find('.mistakes-text').text(localizedTexts.games.typingError);
			break;
		case 2:
		case 3:
		case 4:
			afterPlay.find('.mistakes-text').text(localizedTexts.games.typingErrorsPlural1);
			break;
		default:
			afterPlay.find('.mistakes-text').text(localizedTexts.games.typingErrorsPlural2);
			break;
	}
	if(!won){
		// afterPlay.find('.mistakes-number').addClass('text-red');
		afterPlay.find('.mistakes-arc').addClassSVG('fill-red');
		//afterPlay.find('.mistakes-arc').addClass('fill-red');
	}
	else{
		// afterPlay.find('.mistakes-number').addClass('text-green');
		afterPlay.find('.mistakes-arc').addClassSVG('fill-green');
	}


	this.drawLivesResult(won, gameObject, afterPlay);

	//MISTAKES END

	// LETTERS TYPED START (accuracy levels with infinite text)
	afterPlay.find('.lettersTyped-number').attr('data-maximum', this.getGoodStrokes());
	afterPlay.find('.lettersTyped-number').text(this.allowAnimations ? 0 : this.getGoodStrokes());
	afterPlay.find('.lettersTyped-number').addClass('text-green');
	afterPlay.find('.lettersTyped-arc').addClassSVG('fill-green');
	// LETTERS TYPED END

	//SPEED START
	var speedNumber = afterPlay.find('.speed-number');
	
	speedNumber.attr('aria-label', playerSpeed.toFixed(0));
	speedNumber.text(this.allowAnimations ? 0 : playerSpeed.toFixed(0));
	speedNumber.attr('data-maximum', playerSpeed.toFixed(0));
	
	var degrees = this.getSpeedArrowDegrees(otherPlayersResults);

	// if(parseInt(degrees) <= -45) {
	// 	speedNumber.addClass('text-red');
	// } 
	// else if(parseInt(degrees) <= 45) {
	// 	speedNumber.addClass('text-orange');
	// }
	// else {
	// 	speedNumber.addClass('text-green');
	// }
	//SPEED END

	//TEXTS START
	if (!this.dontInsertTextsAfterPlay) {
		afterPlay
			.find('.header-text').html($('#afterplayHeader-' + this.getStars(won))[0].outerHTML).end();

		var livesAtStart = this.c.remainingLives || this.c.lives;
		if(won && afterPlaySettings.customWinText){
			afterPlay.find('.motivation-text').addClass('text-normal').removeClass('text-semibold').html(
				afterPlaySettings.customWinText
					.replace(/\|hearts\|/g, this.declineLives(this.lives))
					.replace(/\|heartsLost\|/g, this.declineLives(livesAtStart - this.lives))
					.replace(/\|lettersTyped\|/g, this.getGoodStrokes())
			)
		}
		else if(!won && afterPlaySettings.customLossText){
			afterPlay.find('.motivation-text').addClass('text-normal').removeClass('text-semibold').html(
				afterPlaySettings.customLossText
					.replace(/\|hearts\|/g, this.declineLives(this.lives))
					.replace(/\|heartsLost\|/g, this.declineLives(livesAtStart - this.lives))
			)
		}
		else
			afterPlay.find('.motivation-text').text($('#afterplayMotivation-' + this.getStars(won)).text()).end();
		afterPlay.find('.star-comment').text($('#afterplayStarComment-' + this.getStars(won)).text()).end();
	}
	else {

		if(playerSpeed.toFixed(0) <= 150) {
			speedCategory = 'slow';
		} else if(playerSpeed.toFixed(0) <= 300) {
			speedCategory = 'moderate';
		} else {
			speedCategory = 'fast';
		}

		var mistakesNumber = afterPlay.find('.mistakes-number');

		mistakesNumber.removeClass('text-red');
		mistakesNumber.removeClass('text-green');

		if(mistakeCount <= 0) {
			mistakesCategory = 'low';
			mistakesNumber.addClass('text-green');
		} else if(mistakeCount <= 2) {
			mistakesCategory = 'medium';
			mistakesNumber.addClass('text-orange');
		} else {
			mistakesCategory = 'high';
			mistakesNumber.addClass('text-red');
		}

		afterPlay.find('#test-speed-heading-container').html($('#test-heading-' + speedCategory).html());
		afterPlay.find('#test-speed-content-container').html($('#test-content-' + speedCategory).html());
		
		afterPlay.find('#test-mistakes-heading-container').html($('#test-heading-' + mistakesCategory).html());
		afterPlay.find('#test-mistakes-content-container').html($('#test-content-' + mistakesCategory).html());

		// afterPlay.find('.motivation-text').addClass('text-normal').removeClass('text-semibold').html(
		// 	localizedTexts.games.motivationTextPart1 +' <b>' + playerRank.betterThan + localizedTexts.games.motivationTextPart2 + '</b> <br>' + localizedTexts.games.motivationTextPart3
		// )
	}
	//TEXTS END

	//BUTTONS
    if(!won && !afterPlaySettings.playerCannotWin){
        afterPlay.find('.link-restartGame').addClass('red');
    }
    if(!won){
        afterPlay.find('.btn-new-settings').addClass('blue').removeClass("green");
    }
	//BUTTONS END

	//STARS START
	var starCount = this.getStars(won);
	for(var i = 1; i <= starCount; i++){
		afterPlay.find('#star-'+i).addClassSVG('fill-star').removeClassSVG('fill-gray2');
	}

	$('#starsCount').attr('aria-label', $('#starLabel_'+starCount).text());
	//STARS END

	//OTHER START
	if(!won && !afterPlaySettings.playerCannotWin) {
		afterPlay.find('#btnContinue').hide();
		afterPlay.find('.game-heading').removeClass('blue green').addClass('red');
	}
	else {
		afterPlay.find('#btnRestartGame').removeClass('green').addClass('blue');
	}

	if(this.c.speedLimit !== undefined && this.c.speedLimit > 0 && this.getSpeed() < this.c.speedLimit){
		afterPlay.find('.speed-limit-number').text(this.c.speedLimit);
		afterPlay.find('.speed-limit').show();
	}
	$('.round.active .display-current-lives').text(this.lives);
	if(afterPlaySettings.continueOrRestartAll){
		if(won) {
			afterPlay.find('.restart-all-btn').hide();
			afterPlay.find('#btnContinue').show();
			afterPlay.find('#btnRestartGame').removeClass('green').addClass('blue');
		} else{
			afterPlay.find('.restart-all-btn').show();
			afterPlay.find('#btnContinue').hide();
		}
	}
	//OTHER END

/*    if(this.showFluency)
    	afterPlay.find('.afterplay-fluency-block').css({display: "inline-block"});
*/
	$('#gameCanvas').addClass('resultsDisplayed').html(afterPlay.html()); //add to HTML

	//FUNCTIONS
	if (typeof gameObject !== 'undefined')	{
		$('#gameCanvas').find('.link-restartGame').click(function(e) {
			e.preventDefault();
			gameObject.restartGame();
		})
	}
	setupScrollToTarget();

	$('#gameCanvas').find('.btn-new-settings').click(function(e){
		e.preventDefault();
		parent.focus();
		window.parent.adjRSlideshow.toggleScreen(2);
	});
	//FUNCTIONS END

	//ANIMATIONS START
	this.showHearts(1);
	if (this.allowAnimations) {
		this.loadNumber($('#gameCanvas').find('.mistakes-number'), afterPlaySettings.mistakeLoadDelay);
		this.loadNumber($('#gameCanvas').find('.lettersTyped-number'), afterPlaySettings.speedLoadDelay);
		this.loadNumber($('#gameCanvas').find('.speed-number'), afterPlaySettings.speedLoadDelay);
	}
	this.starsAnimation(1, won);
	
	if ($('.accuracy-level').length > 0) {
		this.updateAccuracyLevelData(this.getGoodStrokes());
	}
	
	if ($('.contestGame').length > 0) {
		this.updateContestData(results);
	}

	//--speed pointer animation
	var degrees = this.getSpeedArrowDegrees(otherPlayersResults);
	if ($('body').hasClass('testround') && this.lives > 0 && this.getSpeed().toFixed(0) < this.minSpeed && degrees > -75){
		degrees = -75;
	}
	$( { counter: -90 } ).stop(true).animate( { counter: degrees } , {
	    duration : 3000,
	    easing: 'swing',
	    step: function () {
	        $('#gameCanvas').find('.speed-pointer').css('transform', 'rotate(' + this.counter + 'deg)');
	    }
	}).promise().done(function(){
		$('#gameCanvas').find('.speed-pointer').data('rot', degrees);
	});
	//ANIMATIONS END

	this.useOtherPlayersResults(afterPlay, mistakeCount, playerSpeed);

    //FLUENCY START
/*    if(this.showFluency) {
        var gameData = app.gameData.get("letter");
        app.fluency.resetFluencyModule();
        app.fluency.lineChart.show("fluency-canvas", gameData);

        if (!app.fluency.deltaData.length)
            app.fluency.transformData(gameData);
        app.fluency.showAfterPlayRating(app.fluency.deltaData);
    }
    */
    //FLUENCY END
},

updateXPInfo: function(afterPlay, xpInfo, results) {

	this.updatePlayerXpBar(xpInfo, results);

	this.updateDailyReward(afterPlay,xpInfo['daily'], results);
},

updatePlayerXpBar: function(xpInfo, results) {

	const playerXpInfo = xpInfo['playerXpInfo'];
	const gameReward = xpInfo['gameReward'];

	$.post(
		gameReward['xpAmountUrl'], 
		{gameData: results},
		function(data) 
		{
			
			(new XpBar()).animate(xpInfo['xpRequirements'], playerXpInfo, data['xpToAdd']);
		}
	);	

},

updateDailyReward: function(afterPlay, dailyInfo, results) {




	let dailyPercentageAfter = Math.round(((dailyInfo['gameTime'] + results.time) / dailyInfo['threshold']) * 100);
	if(dailyPercentageAfter >= 100) { dailyPercentageAfter = 100; }
	if(dailyPercentageAfter <= 0) { dailyPercentageAfter = 0; }

	const timeStart = dailyInfo['threshold'] - dailyInfo['gameTime'];
	

	(new DailyReward()).animate(dailyPercentageAfter, null, dailyInfo['threshold'], timeStart, results.time);


	const timeLeftAfter = dailyInfo['threshold'] - (dailyInfo['gameTime'] + results.time);

	if(timeLeftAfter <= 0) 
	{ 
		const treasureChestElement =  $('.daily-reward-col .treasure-chest');

		if(!treasureChestElement.hasClass('opened')) 
		{
			const dailyRewardInfoElement = $('.dailyRewardInfo');
			dailyRewardInfoElement.html(dailyRewardInfoElement.attr('data-readytext'));

			setTimeout(() => {
				$('.treasure-progress-bar')[0].style.setProperty('--progress', Number(100));
				new TreasureChest(treasureChestElement).unlock();
			}, 300);
		}
	}
	



},

updateWeeklyReward: function(afterPlay, weekInfo) {

	const weekInfoObject = weekInfo['object'];

	const weeklyDaysInfoElement = $('.weeklyRewardDaysInfo');

	weeklyDaysInfoElement.html(weekInfo['text']);


	if(weekInfoObject['shouldBeUpdated'])
	{
		const todayCircle = $(`.day-circle-${weekInfoObject['position'] + 1}`);
		todayCircle.addClass('lit');	
		
	
		if(todayCircle.hasClass('chest')) 
		{ 
			weeklyDaysInfoElement.html(weeklyDaysInfoElement.attr('data-readyingametext'));

			const treasureChestElement =  todayCircle.find('.treasure-chest')
			new TreasureChest(treasureChestElement).unlock(false, false);
		}
		else 
		{
			weeklyDaysInfoElement.html(weeklyDaysInfoElement.attr('data-nextdaytranslation'));
		}
	}

	// const weekProgress = weekInfoObject['position'];
	// if(weekProgress > 0) 
	// {
	// 	for(i = 1; i <= weekProgress; i++) 
	// 	{
	// 		$(`.day-circle-${i}`).addClass('lit-no-animation');
	// 	}

	// 	if(weekProgress >= 7) 
	// 	{
	// 		const treasureChestElement = $('.day-streak-days-row .treasure-chest')
			
	// 		const treasureChest = new TreasureChest(treasureChestElement);
	// 		treasureChest.setOpenedIcon(false);
	// 		treasureChest.setRewardInfoText('openedText');
	// 	}

	// }
},

updateDayStreak: function(afterPlay, streakInfo) {

	const streakTextElement = $('.streak-text');

	if(streakInfo['streak'] === 1) {
		streakTextElement.html(streakTextElement.attr('data-firstdaystreaktext'));
	}
	else if(streakInfo['streak'] > 1) 
	{
		streakTextElement.html(streakTextElement.attr('data-streaktext')); 
		const dayText = streakTextElement.attr('data-daytext'); 
		streakTextElement.find('.streak-number').html(streakInfo['streak'] + ". " + dayText);
	}
	else {
		streakTextElement.html(streakTextElement.attr('data-nostreaktext')); 
	}
	

	streakTextElement.html(streakTextElement.attr('data-todaystreak'));

	if(streakInfo['shouldUpdate'])
	{
		streakTextElement.html(streakTextElement.attr('data-nextstreak'));
	}

},



/**
 * Deprecated comment
 * Computes the desired angle of the speed arrow in the afterPlay screen
 * 		based on the average for the current round (only wins count with speed between 30 and 600).
 *
 * Returns a number in interval [-90 ; 90] (so -90 = arrow pointing left, 0 = pointing up, 90 pointing right).
 * For speed >= 2x the average speed, this returns 90.
 * For speed == 0, this returns -90.
 * The average is positioned in 2/3 of the half-circle, not in the middle - to encourage players somewhat more :)
 * 		So if the player's speed == average speed, then this returns 30.
 * In between these points (0 and average) and (average and max), the degrees function is linear.
 */
getSpeedArrowDegrees: function(otherPlayersResults) {

	if (otherPlayersResults.averageSpeed == 0) {	// we dont have stats for this round
		otherPlayersResults.averageSpeed = 52;
		otherPlayersResults.bestSpeed = 252;
	}

	var speed = this.getSpeed();
	var avgSpeed = otherPlayersResults.averageSpeed;
	// var maxSpeed = otherPlayersResults.bestSpeed;

	var fullCircleSpeed = avgSpeed * 2;
	var breakpointSpeed = fullCircleSpeed / 3;

	if(speed <= breakpointSpeed * 1) 
	{	
		degrees = -90 + (speed / breakpointSpeed * 45);
	} 
	else if(speed <= breakpointSpeed * 2) 
	{
		degrees = -45 + (speed - breakpointSpeed) / breakpointSpeed * 90;
	} 
	else 
	{
		degrees = 45 + (speed - breakpointSpeed * 2) / breakpointSpeed * 45;
	}

	if(degrees >= 90) {
		return 90;
	} else if(degrees <= -90) {
		return -90;
	}

	return degrees;
},

showAccuracy: function(element){
  var value = element.data('maximum');
  //var value = $('.game ' + elementName).prop('data-maximum');
  //alert(value);
  $({counter: 0}).stop(true).animate({counter: value}, {
      duration : 3000,
      easing: 'swing',
      step: function () {
          $(document).find('.game').find('#accNumber').text(this.counter.toFixed(1));
          //alert(elementName);
      }
  }).promise().done(function () {
      $(document).find('.game').find('#accNumber').text(value);
  });
},

showSpeed: function(element){
  var value = element.data('maximum');
  //var value = $('.game ' + elementName).prop('data-maximum');
  //alert(value);
  $({counter: 0}).stop(true).animate({counter: value}, {
      duration : 3000,
      easing: 'swing',
      step: function () {
          $(document).find('.game').find('#speedValue').text(this.counter.toFixed(0));
          //alert(elementName);
      }
  }).promise().done(function () {
      $(document).find('.game').find('#speedValue').text(value);
  });
},

getMistakes: function() {
	return false
},

/**
 * // Prepares results into single object
 * @param  int won  1 = won, 0 = lost
 * @param  int isFinished  0 = function is called at the beginning of the game, 1 = function is called at the end of the game
 */
getResults: function(won, isFinished) {

	if (isFinished == undefined) {
		isFinished = 1;
	}
	

	var mistakes
	if(isFinished == 0) 
	{
		mistakes = [];
	} 
	else 
	{
		if(this.gameName === "TestProgram") {
			mistakes = this.getMistakes(app.gameData.get(), this.lines)
		}
		else {
			mistakes = this.getMistakes(app.gameData.get())
		}
	}


    

	if (this.c.timeLimit) {
		var gameTime = (this.getGameTime() / 1000).toFixed(1);
	} else {
		var gameTime = (this.getTypingTime() / 1000).toFixed(1);
	}

    var results = {
        roundId: this.c.roundId,
        won: won,
        time: gameTime,
        accuracy: (this.getAccuracy()).toFixed(2),
        speed: (this.getSpeed()).toFixed(1),
        cleanSpeed: (this.getCleanSpeed()).toFixed(1),
        stars: this.getStars(won),
        typos: this.getTyposCount(),
        goodStrokes: this.getGoodStrokes(),
        maxLives: this.c.lives,
        lives: this.lives,
        gameCategory: this.gameCategory || 'standard',
        contestId: this.contestId || null,
		publicContestId: this.publicContestId || null,
		publicContestRoundId: this.publicContestRoundId || null,
		publicContestPlayerId: this.publicContestPlayerId || null,
		contestGameTableService: this.contestGameTableService || null,
        introTestGameNumber: this.introTestGameNumber || null,
        mistakes: mistakes,
		isFinished: isFinished
    };

	if(this.publicContestId) {
		results.allStrokes = this.getAllStrokes();
	}


    if (this.gameCategory == 'adjustableRound') {
        results.adjustableRoundParams = this.adjustableRoundParams;
    }

    // FLUENCY DATA
    /*if(this.showFluency) {
        var gameDataFluency = app.gameData.get("letter");
        results.fluencyDataUriPromise = app.fluency.lineChart.toDataUri.getPromise("fluency-canvg-svg", gameDataFluency);
        if (!app.fluency.deltaData.length) // FAIL SAFE
            app.fluency.transformData(gameDataFluency);
        results.fluency = app.fluency.getFluencyStat(app.fluency.deltaData);
    }*/

    var dataToLog = {
    	'getResults_results': results,
    	'url': window.location.href,
    	'userAgent': navigator.userAgent,
    	'currentTime': new Date().getTime(),
    	'gameTime': gameTime,
    	'startTime': this.startTime,
    	'invalidGameTime': this.invalidGameTime,
    	'good_keystrokes': this.good_keystrokes,
    	'gamePausedTime': this.gamePausedTime,
		'gameFinalSpeed': this.gameFinalSpeed,
		'gameFinalCleanSpeed': this.gameFinalCleanSpeed,
		'lastKey': this.lastKey,
		'results.points': this.results.points,
		'results.mistakes': this.results.mistakes,
		'results.keystrokes': this.results.keystrokes,
		'results.good_keystrokes': this.results.good_keystrokes,
		'lastStrokeTime': this.lastStrokeTime,
		'url': window.location.href,
		'userAgent': navigator.userAgent
    };

    
    if (typeof gameResultsLogUrl !== "undefined" && results.speed > 1000) {
	    $.ajax({
	      method: "POST",
	      url: gameResultsLogUrl,
	      data: dataToLog
	    });
    }

	return results
},

/**
 * // Saves results (AJAX) to database.
 */
saveResults: function(results) {
	if (!this.l.saveResultsUrl) { return; }

    var sendData = function(url, resultsOut) {
        $.ajax(url, {
            'data': resultsOut,
            'dataType': 'json',
            'method': 'post',
            'attempts': 3,
            'success': function (data, status) {

				if(data.error) {
					window.location.reload();
					alert(data.error);
				}

                if (data.snippets) {
                    for (var snippet in data.snippets) {
                        $("#" + snippet).html(data.snippets[snippet]);
                    }
                }
            },
            'error': function (jqXHR, status, errorThrown) {
            	var errorData = {'source': 'saveResultsOnError', 'status': status, 'errorThrown': errorThrown, 'responseText': jqXHR.responseText, 'attempts': this.attempts};
            	$.ajax({
			      method: "POST",
			      url: errorLogUrl,
			      data: errorData
			    });

            	if (this.attempts > 0) {
            		this.attempts--;
			    	$.ajax(this);
            	}
            }
        });
    };

    var dataToLog = {'saveResults1_results': results};

    // SEND DATA
    var url = this.l.saveResultsUrl;
	/*if(this.showFluency) { 
        results.fluencyDataUriPromise.then(function(dataUri) {
            delete results.fluencyDataUriPromise
            results.fluencyDataUri = dataUri;
            sendData(url, results);
        }).catch(function(reason) {
            delete results.fluencyDataUriPromise
            sendData(url, results);
		});
	}
	else {
		dataToLog.saveResults2 = 'resultsUnchanged';*/
		sendData(url, results);
	//}
	/*
	dataToLog.url = window.location.href;
	dataToLog.userAgent = navigator.userAgent;

	if (typeof gameResultsLogUrl !== "undefined" && results.speed > 100) {
		$.ajax({
	      method: "POST",
	      url: gameResultsLogUrl,
	      data: dataToLog
	    });
	}*/
},

getStars: function(won) {
	if (!won) return 0;

	if (this.getTyposCount() <= 1) {
		return 3;
	} else if (this.getTyposCount() <= 3) {
		return 2;
	} else {
		return 1;
	}
},

repeatString: function(string, count) {
    if (count < 1) return '';
    var result = '';
    while (count > 1) {
        if (count & 1) result += string;
        count >>= 1, string += string;
    }
    return result + string;
},

// Reset common game variables to defaults
resetGameVariables: function(isNewGame) {
	var isNewGame = (typeof isNewGame !== 'undefined') ? isNewGame : false;

	this.gameUnstarted = true;
	this.gameDisplayed = true;
	this.gameOver = false;
	this.gamePlaying = false;
	this.gamePaused = false;
	this.gamePausedTime = 0;
	this.gameFinalSpeed = 0;
	this.gameFinalCleanSpeed = 0;
	this.lastKey = '';

	this.results.points = 0;
	this.results.mistakes = 0;
	this.results.keystrokes = 0;
	this.results.good_keystrokes = 0;

	this.lastStrokeTime = 0;
	this.invalidGameTime = 0;
	this.timeBetweenWords = 0;	

	this.lastProgressValue = 0;

	if (!isNewGame) {
		$('#gameCanvas').removeClass('resultsDisplayed').html('');
		this.c.tooltips = [];
	}
},

setGameVariablesOnGameEnd: function() {
	this.gamePlaying = false;
	this.gameOver = true;
	this.gameFinalSpeed = this.getSpeed();
	this.gameFinalCleanSpeed = this.getCleanSpeed();

	if(this.publicContestId) {
		this.preventRefreshInPublicContest()
	}
},

addTooltip: function(text, arrow, callback){
	var t = this;
	if(typeof t.layers.tips_layer === 'undefined'){
		t.layers.tips_layer = new Kinetic.Layer();
		t.stage.add(t.layers.tips_layer);
	}
	var tipObject = {}
	var tipImg = new Image();
	tipImg.onload = function () {
	    var image = new Kinetic.Image({
	        image: tipImg,
	        x: arrow.posX,
	        y: arrow.posY,
	        width: arrow.width,
	        height: arrow.height,
	        scaleX: arrow.flipX ? -1 : 1,
	        scaleY: arrow.flipY ? -1 : 1,
	        opacity: typeof arrow.opacity === 'undefined' ? 0 : arrow.opacity
	    });
	    t.layers.tips_layer.add(image);
	    image.moveToTop();
	    tipObject.image = image;
	    t.layers.tips_layer.draw();
		callback(tipObject)
	}
	tipImg.crossOrigin="anonymous";
	tipImg.src = t.l.imgUrl+arrow.image;
	t.layers.tips_layer.draw();

	var tipText = new Kinetic.Text({
		text: text.text,
		fontSize: typeof text.fontSize === 'undefined' ? 18 : text.fontSize,
		fontWeight: 'bold',
		fontFamily: 'Open Sans, Arial',
		fill: 'red',
		x: text.posX,
		y: text.posY,
		opacity: typeof text.opacity === 'undefined' ? 0 : text.opacity
	});
	if (isFirefox) {
		if (!text.opacity || text.opacity != 1) {
			tipText.visible(false);
		}
	}
	tipObject.text = tipText;
	t.layers.tips_layer.add(tipText);
	t.layers.tips_layer.draw();
	tipObject.setOpacity = function(val){
		tipObject.image.setOpacity(val);
		tipObject.text.setOpacity(val);
		if (isFirefox) {
			tipObject.image.visible(val);
			tipObject.text.visible(val);
		}
		if(t.layers.tips_layer) t.layers.tips_layer.draw();
	}
	tipObject.hide = function(){
		tipObject.setOpacity(0);
	};
	tipObject.show = function(){
		tipObject.setOpacity(1);
	}
},

letterToKeystrokes: function(letter) {
	var strokes = 1;
	if ("óABCDEFGHIJKLMNOPQRSTUVWXYZ?!(\"@/:".indexOf(letter) !== -1) strokes = 2;
	if ("ďňťÁÉÍÓÚÝ".indexOf(letter) !== -1) strokes = 3;
	if ("ČĎĚŇŘŠŤŽ".indexOf(letter) !== -1) strokes = 4;

	return strokes;
},

spellLetter: function(letter, $case) {
	
	var $case = $case || 1;		// jazykovy pad, default 1
	
	if (typeof(this.phonetics[$case][letter.toLowerCase()]) == 'undefined') {		// kdyz znak neumime vyspellovat v danem pade, zkusime to v prvnim
		$case = 1;	
	}

	if (letter == letter.toLowerCase()) {		// je to male pismeno nebo jiny znak (interpunkce)
		return this.phonetics[$case][letter] || letter;		// pokud nemame spelling, vratime puvodni znak
	}
	else {	// je to velke pismeno, prevedeme na male a pridame slovo "velke" v prislusnem pade
		return this.t.capitalLetter[$case] + " " + (this.phonetics[$case][letter.toLowerCase()] || letter.toLowerCase());
	}
},

sayInfo: function(text) {
	this.say(text, false, false, true)
},

getTextToSay: function(text, mustBeSpelled, spellNow, isInfoText, delay) {
	var spell = mustBeSpelled || spellNow;

	var interpunction = ".,?!()\"-@/:;";
	var letters = text.split('');

	var t = this;

	if (spellNow && this.readWordsInAdvance) {
		var firstWord = text.split(' ')[0];
	}

	
	if (!isInfoText) {
		if (spell) {
			var spellUntil;
			if (spellNow && this.readWordsInAdvance && text.indexOf(' ') > 0) {		// spell only first word
				spellUntil = text.indexOf(' ');		// first space
			}
			else {
				spellUntil = letters.length;	// the end
			}

			var lettersToSpell = letters.slice(0, spellUntil);
			$.each(lettersToSpell, function(i) {
				if (this == '_') return;
				lettersToSpell[i] = t.spellLetter(lettersToSpell[i]);
			});

			text = lettersToSpell.join(', ');

			
			var restOfLetters = letters.slice(spellUntil + 1);
			$.each(restOfLetters, function(i) {
				if (this == '_') return;
				if (interpunction.indexOf(restOfLetters[i]) != -1) {	// hlaskovani interpunkce
					restOfLetters[i] = " " + t.spellLetter(restOfLetters[i]) + " ";
				}
			});

			text += ' ' + restOfLetters.join('');
		}
		else {
			$.each(letters, function(i) {
				if (this == '_') return;
				if (interpunction.indexOf(letters[i]) != -1) {	// hlaskovani interpunkce
					letters[i] = " " + t.spellLetter(letters[i]) + " ";
				}
			});
			text = letters.join('');
		}
	}
	
	// hlaskovani
	/*$.each(letters, function(i) {
		if (this == '_') return;
		//if (this == '<span aria-hidden="true">_</span>') return;

		if (spell) {
			letters[i] = t.spellLetter(letters[i]);
		} 
		else if (!isInfoText && interpunction.indexOf(letters[i]) != -1) {	// hlaskovani interpunkce
			letters[i] = " " + t.spellLetter(letters[i]) + " ";
		}
	})*/

	//text = letters.join(spell ? ', ' : '');


	// velka pismena: explicitne je oznamujeme, napr. namisto "Jirka" vypiseme "velké jé Jirka"
	if (!isInfoText) {
		var words = text.split(' ');

		$.each(words, function(i) {
			var firstLetter = this.charAt(0);
			if (firstLetter != firstLetter.toLowerCase()) {	// velke pismeno
				words[i] = t.t.capitalLetter[1] + " " + (t.phonetics[1][firstLetter.toLowerCase()] || firstLetter.toLowerCase()) + " " + words[i];
			}
		});

		text = words.join(' '); 
	}

	return text;
},


say: function(text, mustBeSpelled, spellNow, isInfoText, delay) {

	if (text === null) return;	// nothing to say

	delay = delay || 0;
	isInfoText = isInfoText || false;
	

	if (typeof($('#gameTextForScreenReaders').data('prefixLen')) == 'undefined') {
		var prefixLen = 0;
	}
	else {
		var prefixLen = ($('#gameTextForScreenReaders').data('prefixLen') + 1) % 2;
	}

	$('#gameTextForScreenReaders').data('prefixLen', prefixLen);
	$('#gameTextForScreenReaders').data('isInfoText', isInfoText);
	$('#gameTextForScreenReaders').data('text', text);
	$('#gameTextForScreenReaders').data('mustBeSpelled', mustBeSpelled);


	var textToSay = this.getTextToSay(text, mustBeSpelled, spellNow, isInfoText, delay);
	var t = this;

	// samotny vypis textu
	var roundNumber = window.location.href.slice(-1);

	if (true /*roundNumber == 8*/) {
		if (delay > 0) {
			var t = this;
			this.delayAfterStartTimer = setTimeout(function() {
				$('#gameTextForScreenReaders').html('');
				$('#gameTextForScreenReaders').html(t.generatePrefix(prefixLen) + textToSay);	
		    }, delay);
		}
		else {
			$('#gameTextForScreenReaders').html('');
			$('#gameTextForScreenReaders').html(t.generatePrefix(prefixLen) + textToSay);
		}
	}
	else {

		var usedSpan = $('#gameTextForScreenReaders').data('usedSpan');
		if (typeof(usedSpan) === "undefined") {
			$('#gameTextForScreenReaders').html('<span class="span1" aria-live=”assertive”>'+textToSay+'</span><span class="span2" aria-live=”assertive”></span>');
			$('#gameTextForScreenReaders').data('usedSpan', 1);
		}
		else {
			this.setTextToSay(textToSay, usedSpan);
		}
	}
},

generatePrefix: function(prefixLen) {
	var prefixString = '';	// prefixLen is a number of underscores we should add
	for (var i=0; i<prefixLen; ++i) {
		prefixString += '_';
		//prefixString += '<span aria-hidden="true">_</span>';
	}

	return prefixString;
},

lastEnterPress: null,


setTextToSay: function(text, usedSpan) {
	
	var spanToUse = usedSpan == 2 ? 1 : 2;

	$('.span'+usedSpan, '#gameTextForScreenReaders').html('');
	$('.span'+spanToUse, '#gameTextForScreenReaders').html(text);
	$('#gameTextForScreenReaders').data('usedSpan', spanToUse);

},


setupStartButton: function() {
	var t = this;

	$('.press-space-to-start').on('click', () => {
		if (!t.gameUnstarted || t.gamePlaying) return;
		t.startGame();
	});
	document.addEventListener('keyup', event => {
		if (event.code === 'Space') {
			if (!t.gameUnstarted || t.gamePlaying) return;
			t.startGame();	
		}
	})

	$('#startGameButton').click(function(e) {
		e.preventDefault();

		if (t.gameUnstarted && !t.gamePlaying) {
			t.startGame();
			$(this).hide();
		}
	});


	// co se stane pri navratu do hry (do inputu pod hrou)
	$('#continueGameButton').click(function(e) {
		e.preventDefault();

		t.gamePaused = false;
		if (typeof t.onGameContinue == "function") {
			t.onGameContinue();
		}

		$(this).hide().removeAttr('accesskey');
		$('#startGameButton').attr('accesskey', 'j');
		$('#gameFormInput').focus();
		if ($('#gameTextForScreenReaders').data('previousText')) {
			t.say($('#gameTextForScreenReaders').data('previousText'), $('#gameTextForScreenReaders').data('previousMustBeSpelled'), null, $('#gameTextForScreenReaders').data('previousIsInfoText'));
		}
		t.startWatchingKeyboard();

	});

	// co se stane pri opusteni hry (inputu pod hrou)
	$('#gameFormInput').blur(function(e) {
		if (t.gamePlaying) {
			t.gamePaused = true;
			clearTimeout(t.delayAfterStartTimer);
			clearTimeout(t.spaceReminderTimer);
			t.stopWatchingKeyboard();
			$('#startGameButton').removeAttr('accesskey');
			$('#continueGameButton').show().focus().attr('accesskey', 'j');
			$('#gameTextForScreenReaders').data('previousText', $('#gameTextForScreenReaders').data('text'));
			$('#gameTextForScreenReaders').data('previousMustBeSpelled', $('#gameTextForScreenReaders').data('mustBeSpelled'));
			$('#gameTextForScreenReaders').data('previousIsInfoText', $('#gameTextForScreenReaders').data('isInfoText'));
			t.sayInfo($('#gameTextForScreenReaders').attr('data-gamePausedText') + ' ' + t.getAccessKeyShortcut('J') + '.'); 
		}
	});

	$('#startGameButton').show();
	$('#continueGameButton').hide();
},

getAccessKeyShortcut: function(accesskey) {
	// podle https://www.w3schools.com/tags/att_global_accesskey.asp
	
	if (navigator.platform.toLowerCase().indexOf('mac') > -1) {		// Mac
		return 'Ctrl + Alt + ' + accesskey;
	}
	else if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1) {		// Firefox
		return 'Alt + Shift + ' + accesskey;
	}
	else {
		return 'Alt + ' + accesskey;
	}
},

playProgressSound: function(step) {
	if (!this.allowSounds) return;

	if (typeof this.sounds.drop[step] != 'undefined') {
		this.sounds.drop[step].play();
	}
},

soundsInit: function() {
	if (this.allowSounds) {
		this.sounds = {
			error: document.getElementById('errorSound'),
			drop: {
				1: document.getElementById('drop1'),
				2: document.getElementById('drop2'),
				3: document.getElementById('drop3')
			},
			victory: document.getElementById('victory'),
			loss: document.getElementById('loss')
		}
	}
},

endGameIfNotWriting: function() {

	if(this.publicContestId) {
		return;
	}

	clearTimeout(this.notWritingTimeout);
	this.notWritingTimeout = null;	

	var t = this;

	this.notWritingTimeout = setTimeout(function() 
	{ 	
		clearTimeout(t.notWritingTimeout);

		t.lives = 0;
		
		if(t.publicContestId) {
			t.endGame(1);
		} else {
			t.endGame();
		}


	}, 15 * 1000);

},

restartInPublicContest: function(restartLink) {

	if(this.publicContestPlayerLives && this.gamePlaying) 
	{
		confirmText = $('.reloadConfirmText').attr('data-reloadConfirmText');
		
		if(confirm(confirmText))
		{
			$(window).off('beforeunload', (function() { return confirmText }));
			window.location.replace(restartLink);
		} 
		else
		{
			this.pauseGame();
		}
	} 
	else 
	{
		window.location.replace(restartLink);
	}	
},

preventRefreshInPublicContest: function() {
	
	if(this.publicContestPlayerLives && this.gamePlaying) 
	{
        $(window).bind('beforeunload', function(){
          return $('.reloadConfirmText').attr('data-reloadConfirmText');
        });
    } else 
	{
		$(window).off('beforeunload');
	}
},

hideCursor: function() {
	$('#gameCanvas').css('cursor', 'none');
},
showCursor: function() {
	$('#gameCanvas').css('cursor', 'initial');
},


getCommonColors_darkmode: function() 
{
	return {
		'text': {
			'good': "#6bbb53",
			'wrong': "#d56151ff",
			'other': "white",
			'current': "#ffa600",
			'secondCurrent': '#a0a0a0',
			'thirdCurrent': '#c0c0c0',
			'unknown': 'white',
			'black': 'white',
		},

		'black': "white",
		'green': "#6bbb53",
		'sweepingLine': "#C2C2C2",

		'pointBar': {
			'fill': "white",
			'stroke': "white",
			'text': "white",
		},
		'startTip': {
			'text': "white",
			'separator': "white",
		},
	};
},
getCommonColors_standard: function() 
{
	return {
		'text': {
			'good': "#3f3f41",
			'wrong': "#d56151ff",
			'other': "#a0a0a0",
			'current': this.levelColorAlternative,
			'secondCurrent': '#a0a0a0',
			'thirdCurrent': '#c0c0c0',
			'unknown': '#606060',
			'black': "#3f3f41",
		},

		'black': "black",
		'green': "green",
		'sweepingLine': "#C2C2C2",

		'pointBar': {
			'fill': "white",
			'stroke': "white",
			'text': "white",
		},
		'startTip': {
			'text': startTipTextColor,
			'separator': "#545455",
		},
	};
},
getCommonColors_visuallyImpaired: function() 
{
	return {
		'text': {
			'good': "#64AE4F",
			'wrong': "#d56151ff",
			'upperCase': "#d000ff",
			'other': "black",
			'current': "black",
			'secondCurrent': '#a0a0a0',
			'thirdCurrent': '#c0c0c0',
			'unknown': 'black',
			'black': "black",
		},

		'black': "black",
		'green': "green",
		'sweepingLine': "#C2C2C2",

		'pointBar': {
			'fill': "white",
			'stroke': "white",
			'text': "white",
		},
		'startTip': {
			'text': startTipTextColor,
			'separator': "#545455",
		},
	};
},
getCommonColors: function(isDarkmode, isVisuallyImpaired) 
{
	if(isDarkmode) 
	{
		return this.getCommonColors_darkmode();
	}
	else 
	{
		if(!isVisuallyImpaired) { return this.getCommonColors_standard(); }
		else { return this.getCommonColors_visuallyImpaired(); }
	}
	
},

showBuyFullVersionInfo: function() {

	const paymentBoxTextType = this.getPaymentBoxTextType();
	this.layers.message_layer = new Kinetic.Layer();


	this.message1Text = new Kinetic.Text({
		text: localizedTexts.games.buyFullVersion[paymentBoxTextType].header,
		fontSize: this.g.message1.fontSize + 5,
		fontFamily: this.g.message1.fontFamily,
		fontStyle: this.g.message1.fontStyle,
		fill: this.g.message1.color,
		width: this.g.message1.width + 70,
		padding: 10,
		lineHeight: 1.2,
		align: 'center',
		y: -70
	});
	this.message2Text = new Kinetic.Text({
		text: localizedTexts.games.buyFullVersion[paymentBoxTextType].subheader,
		fontSize: this.g.message1.fontSize - 5,
		fontFamily: this.g.message1.fontFamily,
		fontStyle: this.g.message1.fontStyle,
		fill: this.g.message1.color,
		width: this.g.message1.width,
		padding: 10,
		lineHeight: 1.2,
		align: 'center',
		y: -30
	});
	this.message3Text = new Kinetic.Text({
		text: localizedTexts.games.buyFullVersion[paymentBoxTextType].cta,
		fontSize: this.g.message1.fontSize,
		fontFamily: this.g.message1.fontFamily,
		fontStyle: this.g.message1.fontStyle,
		fill: this.g.message1.color,
		width: this.g.message1.width,
		padding: 10,
		lineHeight: 1.2,
		align: 'center',
		y: 100
	});



	this.messageRect = new Kinetic.Rect({
		stroke: this.g.message1.borderColor,
		strokeWidth: 0,
		width: this.g.message1.width,
		height: this.message1Text.getHeight() + this.message2Text.getHeight(),
		shadowColor: this.common.colors.black,
		shadowBlur: 10,
		shadowOffset: [10, 10],
		shadowOpacity: 0.4,
		cornerRadius: 5,
		fill: this.g.message1.fill
	});


	this.layers.message_layer.add(this.message1Text);
	this.layers.message_layer.add(this.message2Text);
	this.layers.message_layer.add(this.message3Text);
	
	this.layers.message_layer
		.setX(this.stage.getWidth()/2 - this.messageRect.getWidth()/2)
		.setY(this.stage.getHeight()/2 - this.messageRect.getHeight()/2);
	this.stage.add(this.layers.message_layer);
},
getPaymentBoxTextType: function() {

	if(this.institutionType !== 'individual') return this.role + '_' + this.institutionType;

	if(this.hasExpiredLicence) return 'standard';

	if(this.gameCategory == 'adjustableRound') return 'adjustableRound';
	
	return 'standard';
},

//Return true if the game shouldn't start
onStartGame: function() {

	$('.press-space-to-start').addClass('removed'); 

	if(this.needToBuyFullVersion) 
	{ 
		if(this.institutionType !== 'individual') 
		{
			window.top.location = this.role === 'manager' ? this.paymentPageLink : this.gameMapLink;
		}

		window.top.location = this.paymentPageLink;
		return true;	
	}



},

onEndGame: function() {

	if(afterPlaySettings?.hideGame) 
	{
		setTimeout(() => {
			const animClass = new Animations();
			animClass.fadeout($('#game-container'), 400);
			setTimeout(() => animClass.fadein($('#signup-container'), 400), 401);
		}, 1550);
	}
},




};
